export default "__VITE_ASSET__CuggAom4__"